import dedent from 'dedent';
import { z } from 'zod';
import { createPerformableConfig, TenantId } from '~/tenants/common/registry';
import { coerceBoolean, coerceLiteralNumberRequired, FIRST_VERSION_TIMESTAMP } from '~/lib/zod';

export default createPerformableConfig(
  'portraits',
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
      type: z.enum(['studio', 'onsite']),
      extra_edit: coerceBoolean().optional(),
      extra_pose: coerceBoolean().optional(),
    }),
  },
  {
    name: 'Professional Agent Portraits',
    group: 'Agent Marketing',
    tenant: TenantId.BEYOND_RE_MARKETING,
    thumbnail: 'tenant/bre/portraits/thumbnail_v3.jpg',
    images: [],
    short: dedent`
      We specialize in high-quality headshot and lifestyle photography designed to capture \
      the unique personality and professionalism of real estate agents/teams. Our photos \
      help you stand out, elevate your brand, and make a lasting impression—both within \
      the real estate industry and beyond. Let us help you showcase your best image to \
      clients and colleagues.
    `,
  },
);
